module.exports = __webpack_public_path__ + "img/1.30_Russian_road_sign.d024bd7c.svg";